import MarketingLayout from "@/components/MarketingLayout";
import SEOPageNew from "@/pages/newsite/SEOPageNew";

export default function MetaAdsSpyToolPage() {
  return (
    <MarketingLayout>
      <SEOPageNew />
    </MarketingLayout>
  );
}
